import { useQuery } from "@apollo/client";
import { useState, createContext, useContext, useMemo } from "react";
import { GET_COMPANY } from "../apollo/Queries";
import { useAdmin } from "./AdminContext";

export const AccountContext = createContext();

export const AccountProvider = ({ children }) => {
    const { user, setUser, all_users, setAll_users } = useAdmin();
    const [loader, setLoader] = useState(true);
    const [company, setCompany] = useState(null);
    const [filterState, setFilterState] = useState(''); // 0, 1, '', 'Admin', 'Member'
    const [searchString, setSearchString] = useState('');
    const [sort, setSort] = useState('asc');

    const [sameAsBusiness, setSameAsBusiness] = useState(false);
    // Business Address
    const [businessAddress, setBusinessAddress] = useState({
        street_address: "",
        street_address2: "",
        city: "",
        province: "",
        zip: "",
        country: "",
    });

    // Billing Address
    const [billingAddress, setBillingAddress] = useState({
        street_address: "",
        street_address2: "",
        city: "",
        province: "",
        zip: "",
        country: "",
    });

    console.log("AccountProvider", businessAddress, businessAddress);

    const transformBusinessAddress = (apiAddress) => {
        return {
            street_address: apiAddress.street_address || "",
            street_address2: apiAddress.street_address2 || "",
            city: apiAddress.city || "",
            province: apiAddress.province || "",
            zip: apiAddress.zip || "",
            country: apiAddress.country || "",
        };
    };

    const transformBillingAddress = (apiAddress) => {
        return {
            street_address: apiAddress.street_address || "",
            street_address2: apiAddress.street_address2 || "",
            city: apiAddress.city || "",
            province: apiAddress.province || "",
            zip: apiAddress.zip || "",
            country: apiAddress.country || "",
        };
    };
    const industries = [
        { id: 1, value: "Hospitality" },
        { id: 2, value: "Retail & E-Commerce" },
        { id: 3, value: "Professional Services" },
        { id: 4, value: "Creative & Design" },
        { id: 5, value: "Technology & Software" },
        { id: 6, value: "Healthcare & Wellness" },
        { id: 7, value: "Education & Training" },
        { id: 8, value: "Real Estate & Property Management" },
        { id: 9, value: "Manufacturing & Logistics" },
        { id: 10, value: "Media & Entertainment" },
        { id: 11, value: "Other" },
    ];

    useQuery(GET_COMPANY, {
        fetchPolicy: 'no-cache',
        variables: { company_id: user?.company_id },
        onCompleted: (data) => {
            console.log(36, data);
            debugger;
            if (data?.company) {
                setCompany(data.company);
                setSameAsBusiness(data?.company?.same_address || false);
                if (data?.company?.business_address) {
                    setBusinessAddress(transformBusinessAddress(data?.company?.business_address))

                }
                if (data?.company?.billing_address) {
                    setBillingAddress(transformBillingAddress(data?.company?.billing_address));
                }
                setLoader(false)
            }
        }
    });

    const contextValue = useMemo(() => ({
        loader,
        setLoader,
        all_users,
        setAll_users,
        user,
        setUser,
        searchString,
        setSearchString,
        filterState,
        setFilterState,
        sort,
        setSort,
        sameAsBusiness,
        setSameAsBusiness,
        businessAddress,
        setBusinessAddress,
        billingAddress,
        setBillingAddress,
        industries,
        company,
        setCompany,
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }), [loader, all_users, user, searchString, filterState, sort, sameAsBusiness, businessAddress, billingAddress, company]);

    return (
        <AccountContext.Provider value={contextValue}>
            {children}
        </AccountContext.Provider>
    );
};

export const useAccount = () => {
    const context = useContext(AccountContext);
    if (!context) {
        throw new Error("useAccount must be used within an AccountProvider");
    }
    return context;
};